import { createContext } from 'react';

const ExpandedPathsContext = createContext([{}, () => {}]);

export default ExpandedPathsContext;
